export default {
  // General
  'About {appName}': 'Teave rakenduse {appName} kohta',
  'About Enable Banking API': 'Teave rakenduse Enable Banking API kohta',
  'Application description is not provided.': 'Rakenduse kirjeldust ei esitata.',
  'Authenticate': 'Autentimine',
  'Authentication method': 'Autentimismeetod',
  'Authentication session has expired': 'Autentimisseanss on aegunud',
  'Cancel': 'Tühistamine',
  'Click {0} button if you have confirmed authorization in the BankID app.': 'Kui olete BankID-i rakenduses volituse kinnitanud, klõpsake nupul {0}.',
  'Continue authentication': 'Jätkake autentimist',
  'Cookies must be enabled in your browser to continue': 'Jätkamiseks peavad brauseris olema küpsised lubatud',
  'Enter your OTP code with index {0}': 'Sisestage oma OTP-kood koos indeksiga {0}',
  'Error during authentication:': 'Viga autentimisel:',
  'Error while updating authentication status': 'Autentimise oleku värskendamisel tekkis viga',
  'OTP code': 'OTP-kood',
  'Open the BankID app on this device': 'Avage selles seadmes rakendus BankID',
  'Redirecting to your account servicing provider': 'Suunamine teie konto teenusepakkuja juurde',
  'Returning to the authentication initiator': 'Naasmine autentimise algataja juurde',
  'Start the BankID app on your mobile device and tap the QR code button in the app to scan the QR code on this page': 'Käivitage oma mobiilseadmes BankID rakendus ja vajutage sellel lehel oleva QR-koodi skannimiseks rakenduses nuppu QR-kood',
  'or': 'või',
  'Starting authorization': 'Autoriseerimise alustamine',
  'To continue please use your authentication app': 'Jätkamiseks kasutage oma autentimisrakendust',
  'Try again': 'Proovige uuesti',
  'Submit': 'Esitage',
  'Unable to access server': 'Serverile puudub juurdepääs',
  'Unable to authenticate': 'Autentimine ei õnnestu',
  'Unable to continue authorization': 'Autoriseerimist ei saa jätkata',
  'Unable to continue decoupled authorization': 'Seotud autoriseerimist ei saa jätkata',
  'Unable to handle authentication status "{status}"': 'Autentimise olekut "{status}" ei saa käsitleda',
  'Unknown error occurred': 'Ilmnes tundmatu viga',
  'You need to close this window': 'Peate selle akna sulgema',
  'Authentication cancelled': 'Autentimine tühistati',
  // Consent
  'Authentication is initiated by {0}.': 'Autentimise algatas {0}.',
  'After you complete authentication, {0} will be shared with the authentication initiator.': 'Pärast autentimise lõpetamist jagatakse {0} autentimise algatajaga.',
  'your payment accounts data': 'teie maksekontode andmeid',
  'the list of your payment accounts': 'teie maksekontode loendit',
  'the list of your payment accounts and accounts balances': 'teie maksekontode loendit ja kontosaldode',
  'the list of your payment accounts and accounts transactions': 'teie maksekontode loendit ja kontotehinguid',
  'the list of your payment accounts, accounts balances and transactions': 'teie maksekontode loendit, kontosaldode ja kontotehinguid',
  'By pressing {0} button you agree with the {1}.': 'Nuppu {0} vajutades nõustute järgmisega: {1}',
  'Press {0} button if you are not willing to share your payment accounts data.': 'Kui te pole nõus maksekontode andmeid jagama, vajutage nuppu {0}.',
  // Payment consent
  'Payment details': 'Makse andmed',
  'Payment ID provided by the application: {0}': 'Rakenduse antud makse ID: {0}',
  'Account number where to transfer funds: {0}': 'Konto number, kuhu raha kanda: {0}',
  'Payee name in the payment: {0}': 'Makse saaja nimi makses: {0}',
  'Payee country: {0}': 'Maksesaaja riik: {0}',
  'Payment amount: {0}': 'Makse summa: {0}',
  'Message or reference number in the payment: {0}': 'Sõnum või viitenumber makses: {0}',
  'Payment is initiated by {0}.': 'Makse algatas {0}.',
  'After you complete authentication, your payment consent will be requested by your account servicing payment service provider.': 'Pärast autentimise lõpetamist küsib teie kontot teenindav makseteenuse pakkuja teie makse nõusolekut.',
  'terms of service': 'kasutustingimused',
  'Press {0} button if you are not willing to complete this payment.': 'Kui te ei soovi seda makset sooritada, vajutage nuppu {0}.',
  'Select Payment Account': 'Valige maksekonto',
  'Confirm': 'Kinnita',
  // Backend messages
  '10 digit client number': '10-kohaline kliendinumber',
  '10 digit organisation number (or 12 digit personal number if the company is a sole proprietorship)': '10-kohaline organisatsiooninumber (või 12-kohaline isikukood, kui ettevõte on füüsilisest isikust ettevõtja)',
  '10 digit organization number.': '10-kohaline organisatsiooni number.',
  '17 digit card number (starting with 6703)': '17-kohaline kaardinumber (alates numbrist 6703)',
  '6 digit Handelsbanken customer number': '6-kohaline Handelsbankeni kliendinumber',
  '8 digits CVR number': '8-kohaline CVR number',
  '9 digits Organisasjonsnummer': '9-kohaline Organisasjonsnummer',
  'Agreement number': 'Lepingu number',
  'Agreement number for Nordea Corporate Netbank': 'Nordea korporatiivse internetipanga lepingu number',
  'Bank user ID': 'Panga kasutajatunnus',
  'Business identity code (Y-tunnus) in 1234567-8 format': 'Ettevõtte kood (Y-tunnus) formaadis 1234567-8',
  'Business identity code which is displayed in the Corporate Internet bank settings': 'Ettevõtte isikukood, mis kuvatakse ettevõtte Internetipanga seadetes',
  'Client ID': 'Kliendi ID',
  'Client number': 'Kliendi number',
  'Company ID': 'Ettevõtte ID',
  'Company number': 'Ettevõtte number',
  'Corporate ID': 'Ettevõtte ID',
  'Corporate registration ID': 'Ettevõtte ID',
  'Currency code': 'Valuuta kood',
  'Digit card number': 'digitaalse kaardi number',
  'Disposer': 'Kõrvaldaja',
  'E-mail': 'Meil',
  'E-mail used for authenticating to Holvi': 'Holvi autentimiseks kasutatud meili',
  'Either the 14 digit SEB identifier for the company or the 10 digit organization number': 'Kas ettevõtte 14-kohaline SEB tunnus või 10-kohaline organisatsiooni number',
  'FKDN (without subaccount number): 3 digit branch number + 7 digit customer number': 'FKDN (ilma alamkonto numbrita): 3-kohaline kontorinumber + 7-kohaline kliendinumber',
  'For Swedish Corporates, this is their Organisation number or SHB number, and for Sole Traders (Enskild firma), it is their Personal number, all of which are 10 digits.': 'Rootsi ettevõtete jaoks on see organisatsiooni number või SHB number ja üksikettevõtjate (Enskild firma) isiklik number, mis kõik on 10-kohalised.',
  'IBAN': 'IBAN',
  'ID, NIE, Passport': 'ID, NIE, pass',
  'Login ID used in MyBRD aplications': 'MyBRD rakendustes kasutatav sisselogimise ID',
  'Login Name': 'Kasutaja nimi',
  'Mandate ID': 'Mandaadi ID',
  'Norwegian national identity number in the format DDMMYYXXXXX (11 digits)': 'Norra isikukood vormingus DDMMYYXXXXX (11 numbrit)',
  'Online banking PIN': 'Internetipanga PIN-kood',
  'Online banking Password': 'Internetipanga parool',
  'Organisation ID in the format TBxxxxx or TXxxxxx': 'Organisatsiooni ID vormingus TBxxxxx või TXxxxxx',
  'Organisation number': 'organisatsiooni number',
  'PIN': 'PIN-kood',
  'Password': 'Parool',
  'Password for Aktia Internet bank': 'Aktia internetipanga parool',
  'Password used for authenticating to Holvi': 'Holvi autentimiseks kasutatud parool',
  'Personal ID': 'Isiklik ID',
  'Personal ID number': 'Isikukood',
  'Personal code': 'Isikukood',
  'Personal code of the user': 'Kasutaja isikukood',
  'Personal signatory number': 'isiklik allakirjutaja number',
  'Personal username for online banking': 'Isiklik kasutajanimi internetipanga jaoks',
  'Postbank ID': 'Postipanga ID',
  'Social security number (Personnummer)': 'Sotsiaalkindlustuse number (isiku number)',
  'Social security number in the format YYYYMMDDXXXX': 'Sotsiaalkindlustusnumber vormingus YYYYMMDDXXXX',
  'Swedish social security number in the format YYYYMMDDXXXX': 'Rootsi sotsiaalkindlustuse number vormingus YYYYMMDDXXXX',
  'The IBAN of the user authenticating': 'Autentiva kasutaja IBAN',
  'The currency code': 'Valuuta kood',
  'The user ID of the user authenticating': 'Autentiva kasutaja ID',
  'Unique personal ID number': 'Unikaalne isikukood',
  'User ID': 'Kasutaja ID',
  'User ID for Aktia Internet bank': 'Aktia internetipanga kasutajatunnus',
  'User ID for Nordea Corporate Netbank': 'Nordea Corporate Netipanga kasutajatunnus',
  'User ID for online banking': 'Kasutajatunnus internetipanga jaoks',
  'User ID in the format XX000000': 'Kasutaja ID vormingus XX000000',
  'User ID used to log in to the bank': 'Panka sisselogimiseks kasutatav kasutajatunnus',
  'Username': 'Kasutajanimi',
  'Username used to log in to the bank': 'Panka sisselogimiseks kasutatav kasutajanimi',
  'VR NetKey': 'VR NetKey',
  'WebSSO user name': 'WebSSO kasutajanimi',
}
